import { withSentryReactRouterV6Routing } from '@sentry/react';
/* eslint-disable no-restricted-imports -- this file is the app's abstraction over react-router. */
import {
  BrowserRouter,
  Route,
  Routes,
  MemoryRouter,
  Navigate,
  Outlet,
} from 'react-router-dom';

export { BrowserRouter, Route, Routes, MemoryRouter, Navigate, Outlet };
export type { NavigateProps } from 'react-router-dom';

// NOTE: top-level route trees only. A nested <Routes> under this one gives Sentry
// last-writer-wins transaction names, so sub-routers use the plain Routes export.
export const SentryRoutes = withSentryReactRouterV6Routing(Routes);
